export default __webpack_public_path__ + "static/media/landing_page_bim_analytics.e67924d6.gif";